import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: "#f0f0f0",
        padding: "20px 10px",
        textAlign: "center",
        borderTop: "1px solid #ddd",
        marginTop: "40px"
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} <strong>RE-CONECT</strong> — Consultoria em Gestão de Pessoas
      </Typography>

      <Typography variant="caption" display="block" mt={1}>
        Desenvolvido com ❤️ por Rafael Vilaça
      </Typography>
    </Box>
  );
}
